module.exports = __webpack_public_path__ + "img/img1.cdb1fb7f.png";